module.exports = __webpack_public_path__ + "static/media/paypayduck.a26e0549.png";